import axios from 'axios'
import * as Sentry from '@sentry/react'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't report 401 errors to Sentry (user not logged in)
    if (error.response?.status !== 401) {
      Sentry.withScope((scope) => {
        // Add request context
        if (error.config) {
          scope.setTag('http.method', error.config.method?.toUpperCase())
          scope.setTag('http.url', error.config.url)
          scope.setContext('request', {
            method: error.config.method,
            url: error.config.url,
            baseURL: error.config.baseURL,
            headers: error.config.headers,
            params: error.config.params,
            data: error.config.data,
          })
        }

        // Add response context
        if (error.response) {
          scope.setTag('http.status_code', error.response.status)
          scope.setContext('response', {
            status: error.response.status,
            statusText: error.response.statusText,
            headers: error.response.headers,
            data: error.response.data,
          })
        }

        // Set error fingerprint for better grouping
        scope.setFingerprint([
          error.config?.method || 'unknown',
          error.config?.url || 'unknown-url',
          String(error.response?.status || 'network-error'),
        ])

        // Add user context if available
        const currentUrl = window.location.href
        scope.setContext('page', {
          url: currentUrl,
          pathname: window.location.pathname,
          search: window.location.search,
        })

        Sentry.captureException(error)
      })
    }

    return Promise.reject(error)
  }
)

export { api }
